import React from 'react';
import PropTypes from 'prop-types';

const Feature = ({
  indicator, title, description,
}) => (
  <div className="col-15 col-lg-5 mb-30">
    <a className="features__feature features__feature--height-auto">
      <div className="features__feature__indicator fs-60 fw-900 mb-4">{indicator}</div>
      <h3 className="features__feature__title">{title}</h3>
      <p className="features__feature__description">{description}</p>
    </a>
  </div>
);

Feature.propTypes = {
  indicator: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Feature;
